// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"f92b01d3","904":"ea755250"}[chunkId] + ".chunk.js";
};